import { dictionaryFoundationsService } from '../_services'
import { createStoreModule } from './store-module-factory'

export const dictionaryFoundations = createStoreModule(dictionaryFoundationsService)
